import { render, staticRenderFns } from "./CredorInfoCard.vue?vue&type=template&id=03bcee86&"
import script from "./CredorInfoCard.vue?vue&type=script&lang=js&"
export * from "./CredorInfoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports